/**
 * The codes the API's errors carry (`AppError`), shared like the zod schemas: the web app shows
 * each as its translation "errors.<code>", which en.ts and de.ts must have for every code.
 */
export const APP_ERROR_CODES = [
  "NOT_FOUND",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "GARAGE_NOT_FOUND",
  "GARAGE_REQUIRED",
  "GARAGE_NAME_INVALID",
  "GARAGE_NAME_RESERVED",
  "GARAGE_NAME_TAKEN",
  "PART_IN_USE",
  "PART_LINK_INVALID",
  "PART_LINK_TAKEN",
  "LOCATION_CYCLE",
  "CHASSIS_CODE_EXISTS",
  "MOVEMENT_NOT_UNDOABLE",
  "WORK_ORDER_COMPLETED",
  "WORK_ORDER_NOT_COMPLETED",
  "ORDER_NOT_EDITABLE",
  "ORDER_INVALID_STATUS",
  "ORDER_HAS_RECEIPTS",
  "QTY_BELOW_RECEIVED",
  "FILE_TOO_LARGE",
  "FILE_TYPE_NOT_ALLOWED",
  "UPLOADS_DISABLED",
  "IMPORT_INVALID",
  "PACKAGE_INVALID",
  "PACKAGE_TOO_NEW",
  "PACKAGE_TOO_OLD",
  "SIGN_IN_FAILED",
  "WRONG_PASSWORD",
  "ACCOUNT_DISABLED",
  "ACCOUNT_DELETED",
  "MEMBERSHIP_DEACTIVATED",
  "INVITATION_INVALID",
  "RESET_LINK_INVALID",
  "LAST_GARAGE_ADMIN",
  "LAST_PLATFORM_ADMIN",
  "RATE_LIMITED",
  "EMAIL_TAKEN",
  "ALREADY_MEMBER",
  "PASSWORD_REQUIRED",
  "MAIL_FAILED",
  "NOT_YOURSELF",
  "DEMO_LINK_INVALID",
  "DEMO_BUSY",
  "PIN_WRONG",
  "PIN_WAIT",
  "RECOVERY_CODE_WRONG",
  // The admin app (ADR 0016).
  "OPERATOR_LINK_INVALID",
  "CORE_UNAVAILABLE",
] as const;

export type AppErrorCode = (typeof APP_ERROR_CODES)[number];

/** Whether a value, e.g. from a response body, is one of the codes. */
export function isAppErrorCode(value: unknown): value is AppErrorCode {
  return typeof value === "string" && (APP_ERROR_CODES as readonly string[]).includes(value);
}
